import { useCallback, useEffect, useState } from "react";
import { ArrowBigLeft, ArrowBigRight } from "lucide-react";
import React from "react";
import { getCalendarWeek, setMonthDays } from "@/helper/sort";
import { useNavigate } from "react-router-dom";
import { useApiFetch } from "@/helper/apiFetch";
import { useTranslate } from "@/helper/translate";
import { EventInfoSchema } from "@/components/event/EventSchema";




// Component
export function CalendarPage() {
  const apiFetch = useApiFetch();
  const { translate, formatMonthYear } = useTranslate();

  const now = new Date();
  const initialDate = new Date(now.getFullYear(), now.getMonth(), 1);
  const daysOfWeek = ["KW", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  const [currentDate, setCurrentDate] = useState(initialDate);
  const [events, setEvents] = useState<EventInfoSchema[]>([]);

  const [isLoaded, setIsLoaded] = useState(false);



 





  const backward = () => {
    const newDate = new Date(currentDate);
    newDate.setMonth(currentDate.getMonth() - 1);
    setCurrentDate(newDate);
    setDays();
  };

  const forward = () => {
    const newDate = new Date(currentDate);
    newDate.setMonth(currentDate.getMonth() + 1);
    setCurrentDate(newDate);
    setDays();
  };


  const rows = [];
  let days = [];

  const navigate = useNavigate();


  function setDays() {
    days = setMonthDays(currentDate);
    for (let i = 0; i < days.length; i += 7) {
      const weekDays = days.slice(i, i + 7);
      const weekNumber = getCalendarWeek(weekDays[0]);

      rows.push({ weekNumber, days: weekDays });
    }
  }
  setDays();


  useEffect(() => {
   
     
      apiFetch(`/api/EventPool/GetAllEvents`)
        .then((res) => {
          if (!res.ok) throw new Error("Failed to fetch events");
          return res.json();
        })
        .then((data) => {
          setEvents(data);
          setIsLoaded(true);
          
        })
        .catch((err) => {
          console.error(err);
        });
    

  }, [ ]);




  return (
    <div className="h-[calc(100vh-60px)] flex flex-col">
      <div className="content-header flex justify-between border-b border-gray-300 pt-[0.6rem] pb-[0.6rem] mb-[0.8rem]">
        <div className="flex items-center gap-4">
          <h1 className="font-bold text-2xl">Calendar</h1>

          


        </div>
      </div>



      {!isLoaded ? (
        <div>Loading…</div>
      ) : (

        <div className="flex-1 overflow-auto">
          <div className="overflow-x-auto pb-5">


            <div className="calendarWrapper">
              <div className="occupancyHeader">

                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <div className="calendarNav left" onClick={backward}><ArrowBigLeft /></div>
                  <div style={{ textAlign: "center", fontSize: "25px", cursor: "pointer" }}>{formatMonthYear(currentDate)}</div>
                  <div className="calendarNav right" onClick={forward}><ArrowBigRight /></div>
                </div>
                <div></div>
              </div>
              <table>
                <colgroup>
                  <col style={{ width: "2%" }} />
                  {Array.from({ length: 7 }).map((_, idx) => (
                    <col key={idx} style={{ width: "14%" }} />
                  ))}
                </colgroup>
                <thead>
                  <tr>
                    {daysOfWeek.map((day, idx) => (
                      <td key={idx} className="calendarItem itemHeader">{day}</td>
                    ))}
                  </tr>
                </thead>
                <tbody className="text-[0.8rem]">
                  {rows.map((row, rIdx) => (

                    <React.Fragment key={rIdx}>
                      <tr>
                        <td className="calendarItem calendarKW">{row.weekNumber}</td>
                        {row.days.map((day, dIdx) => (
                          <td
                            key={dIdx}
                            className={day.toDateString() === new Date().toDateString()
                              ? "calendarItem today calendarDay cursor-pointer"
                              : "calendarItem calendarDay cursor-pointer"}
                           
                          >
                            <div className="calendarDayHeader">
                              <div>{day.getDate()}</div>
                            </div>
                            {events.filter(e => new Date(e.DateFrom).toDateString() == day.toDateString()).map((event) => (
                                <div key={event.Id} className="calendarEvent w-100 relative" onClick={() => navigate(`/event?eventId=${event.Id}`)}>
                                  {event.Name}
                                </div>
                              ))}
                           
                          

                          </td>
                        ))}

                      </tr>

                    </React.Fragment>
                  ))}
                </tbody>
              </table></div>



          </div>
        </div>)}

    </div>
  );
}
